module.exports = __webpack_public_path__ + "img/footer_phone.1c8b75de.png";